import React, { Fragment } from 'react'

const FacetedSearchCompact = ({
    facetFilters,
    visibleDropdownMenu,
    toggleVisibleGroup,
    onFacetChange,
    onSubmit,
}) => (
    <ul className="faceted-search faceted-search--compact">
        {facetFilters &&
            facetFilters.map(
                (group, groupIndex, array) =>
                    group.options &&
                    group.options.length > 0 && (
                        <Fragment>
                            <li
                                className="small-12 faceted-search__group"
                                key={`${group.label}-${groupIndex}`}
                            >
                                <div
                                    className="faceted-search__group-header"
                                    role="faceted-search-item-group"
                                    onClick={() => toggleVisibleGroup(group)}
                                >
                                    {group.label}
                                    <i className="icon-arrow"></i>
                                </div>
                                {visibleDropdownMenu.includes(group.id) && (
                                    <ul className="faceted-search__sublist">
                                        <div
                                            className="faceted-search__sublist--back"
                                            onClick={() =>
                                                toggleVisibleGroup(group)
                                            }
                                        >
                                            <i className="icon-arrow"></i>
                                        </div>
                                        {group.options &&
                                            group.options.map(
                                                (item, itemIndex, array) => (
                                                    <Fragment>
                                                        <li
                                                            key={`${item.label}-${itemIndex}`}
                                                            className="faceted-search__item"
                                                            role="faceted-search-item"
                                                        >
                                                            <FacetedFilterCheckbox
                                                                item={item}
                                                                group={group}
                                                                onFacetChange={
                                                                    onFacetChange
                                                                }
                                                            />
                                                        </li>
                                                        <hr />
                                                    </Fragment>
                                                )
                                            )}
                                    </ul>
                                )}
                            </li>
                            <hr />
                        </Fragment>
                    )
            )}
    </ul>
)

const FacetedFilterCheckbox = ({ item, group, onFacetChange }) => (
    <label className="faceted-filter">
        <input
            className="faceted-filter__input"
            type="checkbox"
            onChange={() => onFacetChange(group, item)}
            checked={group.selectedOptions.includes(item.id)}
        />
        <span className="faceted-filter__label">
            {item.label}
            {!isNaN(item.quantity) && item.quantity > 0 && (
                <span className="faceted-filter__quantity">
                    {' '}
                    ({item.quantity})
                </span>
            )}
        </span>
    </label>
)

export default FacetedSearchCompact
